import React, { useEffect, useState } from 'react';
import Menu from '../../../components/Menu';
import api from '../../../services/api';
import {  useParams } from "react-router-dom";



function Fatura(props){    
    const { id } = useParams();

    const [dados, setDados] = useState({});
    const [senha, setSenha] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [msg, setMsg] = useState('');
    const [trava, setTrava] = useState(true);

    const [valor, setValor] = useState('');
    const [periodo, setPeriodo] = useState('');
    const [formaPagamento, setFormaPagamento] = useState('');
    const [tipo, setTipo] = useState('');
    const [statuscheck, setStatusCheck] = useState('');
    const [dataPagamento, setDataPagamento] = useState('');
    
    
    useEffect( () => {
        async function getDados(id){
            try{
                var dados = await api.get('/adm/fatura/'+id);
                setTrava(false);
                setDados(dados.data);
                setValor(dados.data.valor);
                setPeriodo(dados.data.periodo);
                setDataPagamento(dados.data.data_pg);
                setFormaPagamento(dados.data.forma_pg);
                setTipo(dados.data.tipo);
                setStatusCheck(dados.data.status);
             //   console.log(dados.data);
            }catch(e){
                setTrava(true);
                var dados = '';                
            }

        }
       getDados(id);
    },[api, setDados, id]);

    if(!window.localStorage.getItem('token')){
        window.location = './Sair';
        return;
    }

    const Editar = async (e,idfat) => {
        e.preventDefault(0);
       
        try{
            var result = await api.post('/adm/fatura/'+idfat, 
                {
                    valor: valor,
                    periodo: periodo,
                    dataPagamento: dataPagamento,
                    formaPagamento: formaPagamento,
                    tipo:tipo,
                    status: statuscheck
                }
            );
            if(result.data.msg){
                setMsg(result.data.msg);
            }
        }catch(e){
            setMsg('Ocorreu um erro interno, tente novamente mais tarde.');
            
        }
        
    }


    return (<div class="main-content" style={{marginLeft: '0'}}>
        <Menu />
    <div id="page-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-md-4 col-md-offset-4" style={{marginTop: '100px'}}>
                    <img src={'../public/assets/logoupbusca.png'} alt="Up Busca" class="center-block img-responsive" id="logo" style={{marginTop: '-10%'}}/>
                </div>
            </div>
        </div>
    <div>

    {trava == false ? <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <ul class="nav nav-tabs" role="tablist" style={{marginTop: '0px'}}>
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Fatura</a>
                </li>
            </ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane active" id="home">
                    <div class="table-responsive" style={{marginTop: '25px'}}>
                    <div class="row">
			
                        <div>
                            <div class="form-group col-md-12">
                                <span>Usuario:</span>
                                <input type="text" class="form-control" id="usuario" name="usuario" value={dados.usuario} disabled/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Valor:</span>
                                <input type="text" class="form-control" id="valor" name="valor" placeholder="" value={valor} onChange={(e) => setValor(e.target.value)}/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Periodo:</span>
                                <input type="text" class="form-control" id="periodo" name="periodo" placeholder="" value={periodo} onChange={ (e) => setPeriodo(e.target.value) }/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Data pagamento:</span>
                                <input type="text" class="form-control" id="datapg" name="datapg" placeholder="" value={dataPagamento} onChange={ (e) => setDataPagamento(e.target.value) }/>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Forma pagamento:</span>
                                <select value={formaPagamento} onChange={(e) => setFormaPagamento(e.target.value)} class="form-control">
                                <option value={1}>Boleto</option>
                                <option value={2}>Pix</option>
                                </select>
                            </div>

                            <div class="form-group col-md-12">
                                <span>Tipo:</span>
                                <select value={tipo} onChange={(e) => setTipo(e.target.value)} class="form-control">
                                <option value={1}>Contratação</option>
                                <option value={2}>Renovação</option>
                                <option value={3}>Outros</option>
                                </select>
                            </div>


                            <div class="form-group col-md-12">
                                <span>Status:</span>
                                <select value={statuscheck} onChange={(e) => setStatusCheck(e.target.value)} class="form-control">
                                <option value={1}>Pago</option>
                                <option value={2}>Aguardando pagamento</option>
                                <option value={5}>Cancelada</option>
                                </select>
                            </div>

                            
                            <div className='form-groud col-md-12'>
                            {msg.length > 0 ? <center>{msg}</center> : ''}

                                                            <br/>
                                <center>
                                    <button id="btAtualizarSenha" type="button" onClick={(e) => Editar(e, dados.id)} class="btn btn-primary">Editar fatura</button>
                                    <button style={{marginLeft: '10px'}} id="btVoltar" type="button" onClick={(e) => window.history.go(-1)} class="btn btn-dark">Voltar</button>
                                </center>
                            </div>

                        </div>
                        <br/>
                    </div>
                    <br/>
                    </div>
                </div>
            </div>
        </div>
    </div> : (``)}

  
</div>

</div></div>);
}

export default Fatura;
